import cx from 'clsx';
import { useLocalization } from '@fluent/react';

import SignUpButton from './SignUpButton';
import brandLogo from '#/assets/static-page/brand_logo_big.svg';
import { PublicRoute } from '#/constants/page-route';

const SignUpButtonGroupPage: React.FC<SignUpButtonGroupPageProps> = ({ isBgBlue }) => {
  const { l10n } = useLocalization();

  return (
    <div
      className={cx(
        'flex items-center justify-between w-full py-6 px-14',
        !!isBgBlue && isBgBlue ? 'bg-blue-100' : 'bg-white',
      )}
    >
      <div className="flex gap-x-5">
        <img src={brandLogo} className="w-24 hover:cursor-pointer" />
        <div className="space-y-3">
          <div className="text-3xl text-blue-700">Make the right move</div>
          <div className="text-black">
            Maximise your business with us - a one-stop solve all platform for your transportation
            concerns
          </div>
        </div>
      </div>
      <div className="flex flex-col mb-5">
        <SignUpButton
          className="bg-blue-700"
          iconClassName="text-white"
          text={l10n.getString('sign-up-client')}
          textClassName="text-white"
          route={PublicRoute.CustomerSignup}
        />
        <SignUpButton
          className="bg-white border border-blue-700"
          iconClassName="text-blue-700"
          text={l10n.getString('sign-up-transporter')}
          textClassName="text-black"
          route={PublicRoute.LogisticsSignup}
        />
      </div>
    </div>
  );
};

type SignUpButtonGroupPageProps = {
  isBgBlue?: boolean;
};

export default SignUpButtonGroupPage;
